import { mapGetters, mapMutations } from "vuex"
import { formatWholePrice } from "@/helpers";

export default {
  name: "GuidesList",
  props: {},
  emits: [],
  components: {},
  setup() { },
  data() {
    return {
      courseInBasket: [],
    }
  },
  created() { },
  mounted() { },
  watch: {
    basket: function () {
      this.basket.forEach(product => {
        this.courseInBasket.push(product.id);
      });
    },
  },
  computed: {
    ...mapGetters({
      content: "guides/content",
      menu: "setting/headerMenu",
      basket: "basket/basket",
      page: "pages/page",
      isAuthenticated: "auth/isAuthenticated",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
    }),
  },
  methods: {
    formatWholePrice,
    ...mapMutations({
      addWebinarToBasket: "basket/ADD_WEBINAR_ITEM_TO_BASKET",
      changeBasketPopup: "basket/SHOW_BASKET_POPUP",
      changeSeminarInfo: "popups/SHOW_SEMINAR_INFO_POPUP",
      setSeminarInfoContent: "popups/SET_SEMINAR_INFO_CONTENT",
      showSeminarProfessionalOnlyPopup: "popups/SHOW_SEMINAR_PROFESSIONAL_ONLY_POPUP",
    }),
    showSeminarInfoPopup(title, description) {
      this.changeSeminarInfo(true);
      this.setSeminarInfoContent({ title: title, description: description });
    },
    checkCoursesInBasket(id) {
      this.courseInBasket.push(id);
    },
    InBasket(id) {
      return this.basket.find(product => product.id === id);
    },
    handleWebinarToBasket({ product }) {
      if (!this.isProfessional) {
        this.showSeminarProfessionalOnlyPopup(true);
        return;
      }

      this.addWebinarToBasket({
        select_count: 1,
        product,
        product_price: product.productPrices.data[0],
      });
      this.changeBasketPopup(true);
      this.checkCoursesInBasket(product.id);
      this.$toasted.success("Вебінар успішно додано в кошик");
    },
  }
}
